import { transport } from 'config/transport';

export function callApiGetAssets(congDoanId, academicYear, assetSource, assetType) {
    return transport.get(`/congDoan/${congDoanId}/assets`, { params: { academicYear, assetSource, assetType } });
}
